import axios from "axios";
import * as PATH from "../helpers/APIURL";

export default class ScheduleService {

    static addSchedule = (id, data) => {
        return axios.post(`${PATH.ADD_SCHEDULE}/${id}`, data);
    }

    static getScheduleList = (id, params) => {
        return axios.get(`${PATH.GET_SCHEDULE_LIST}/${id}`, {params});
    }

    static getScheduleById = (id, restaurantId) => {
        return axios.get(`${PATH.GET_SCHEDULE_BY_ID}/${id}/${restaurantId}`);
    }

    static editSchedule = (data, id, restaurantId) => {
        return axios.put(`${PATH.EDIT_SCHEDULE}/${id}/${restaurantId}`, data);
    }

    static deleteSchedule = (id, restaurantId) => {
        return axios.delete(`${PATH.DELETE_SCHEDULE}/${id}/${restaurantId}`);
    }

    static getScheduleTime = (id, data) => {
        return axios.get(`${PATH.GET_SCHEDULE_TIME}/${id}`, {params: data});
    }

    static getScheduleShiftList = (id, params) => {
        return axios.get(`${PATH.GET_SCHEDULE_SHIFT}/${id}`, {params});
    }

}
